module.exports = __webpack_public_path__ + "img/frame (152).2aae0368.jpg";